 <div class="spinnerContainer">
    <mat-spinner [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-spinner>
        <h5>{{loadingText | translate}}</h5>
</div>